import { useEffect, useState } from 'react';
import { RadioGroup, FormGroup } from '@tencent/spaui';
import { getMessage } from '@/utils/MessageUtils';
import _ from 'lodash';
import { getLGDialTag } from './api';

interface CallTags {
  firstTag?: string;
  secondTag?: string;
}

interface LGCallLabelRadioGroupProps {
  callTags: CallTags;
  onChange: (callTags: CallTags) => void;
  canChoseList?: string[]; // 能够选择的tag
  useCanChose: boolean; // 是否使用canChoseList
}

const LGCallLabelRadioGroup = (props: LGCallLabelRadioGroupProps) => {
  const [data, setData] = useState<any[]>([]);
  const { callTags, canChoseList, useCanChose } = props;
  useEffect(() => {
    console.log('LGCallLabelRadioGroup----- 准备发送请求---getLGDialTag');

    getLGDialTag()
      .then((res: any) => {
        console.log('[getLGDialTag]res.data 返回结果', res.data);
        if (res.code === 0) {
          const data = _.map(res.data, (tag, i) => {
            console.log('tag,i', tag, i);
            if (i !== 'DIAL_IN_FIRST_NEW_LEAD') {
              return {
                value: i,
                children: getMessage(i, 'DialInFirstTagType'),
                options: _.map(tag, (label, value) => {
                  return {
                    value,
                    children: label,
                  };
                }),
              };
            }
          });
          console.log('[getLGDialTag]result', data);
          setData(_.compact(data));
        }
      }, (err) => {
        console.error('dail-tag err', err);
      });
  }, []);

  const onChange = (e: any, value: string) => {
    props?.onChange({
      firstTag: value,
      secondTag: undefined,
    });
  };

  const handleSecondTag = (e: any, value: string) => {
    props?.onChange({
      firstTag: callTags?.firstTag,
      secondTag: value,
    });
  };

  const _data = _.map(data, (v) => {
    return {
      ...v,
      disabled: useCanChose ? !_.includes(canChoseList, v.value) : false,
    };
  });

  return (
    <>
      <FormGroup className="required" style={{ display: 'flex' }}>
        <label style={{ width: 60 }}>一级：</label>
        <RadioGroup
          data={_data}
          value={callTags?.firstTag}
          onChange={onChange}
          RadioProps={{
            canCancelCheck: true,
          }}
        />
      </FormGroup>
      {
        callTags?.firstTag && <FormGroup className="required"  style={{ display: 'flex' }}>
          <label style={{ width: 60 }}>二级：</label>
          <RadioGroup
            data={_.find(_data, (v) => v.value === callTags?.firstTag)?.options || []}
            value={callTags?.secondTag}
            onChange={handleSecondTag}
            RadioProps={{
              canCancelCheck: true,
            }}
          />
        </FormGroup>
      }
    </>

  );
};

export default LGCallLabelRadioGroup;
